export default function Spinner() {
  return <div className="loader mx-auto" />;
}
